module.exports = __webpack_public_path__ + "static/img/Stefano.4474db1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Stefano.jpg
// module id = Ck5g
// module chunks = 0